if (!customElements.get('dvtb-bundle-picker')) {
  class DvtbBundlePicker extends HTMLElement {
    connectedCallback() {
      this.variantId = this.dataset.variantId;
      this.boxes = Array.from(this.querySelectorAll('.st_bundle-box'));
      this.errorBox = this.querySelector('.st_error-box');

      this.boxes.forEach((box) => {
        box.addEventListener('click', () => this.select(box));
        box.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.select(box);
          }
        });
      });

      // No cart request on page load: writing the cart before anyone asked
      // for it had Shopify start prefetching ~500 KB of checkout scripts on
      // every visit, and nothing needs it — COD is priced by JCA Pay and card
      // checkout builds its own cart permalink. The native forms still get
      // the default tier's quantity; the cart itself follows real selections.
      const activeBox = this.boxes.find((b) => b.classList.contains('active')) || this.boxes[0];
      if (activeBox) this.syncNativeQuantityInputs(parseInt(activeBox.dataset.bundleBoxCount, 10) || 1);
    }

    select(box) {
      if (box.classList.contains('active')) return;
      this.boxes.forEach((b) => b.classList.remove('active'));
      box.classList.add('active');
      // The selection itself, for the page's own UI (the sticky buy bar's
      // price) — announced right away, not only once the cart sync succeeds.
      const quantity = parseInt(box.dataset.bundleBoxCount, 10) || 1;
      document.dispatchEvent(new CustomEvent('dvtb:bundle-updated', { detail: { quantity } }));
      this.syncCart(box);
    }

    /**
     * Keeps the real Shopify cart on the selected tier. A background
     * convenience only — COD orders are priced by JCA Pay and card checkout
     * builds its own cart permalink — so a failed sync is never shown to the
     * shopper. It used to be: any network hiccup, or Shopify's bot check
     * answering with an HTML page instead of JSON, surfaced as "no tenemos
     * suficiente stock", which was never true. The stock message is now
     * reserved for Shopify actually refusing the quantity (HTTP 422).
     */
    syncCart(box, options) {
      options = options || {};
      const quantity = parseInt(box.dataset.bundleBoxCount, 10) || 1;
      if (!this.variantId) return;

      this.syncNativeQuantityInputs(quantity);
      if (this.errorBox) this.errorBox.classList.remove('is-visible');

      // Only the latest selection's answer counts: rapid switching must not
      // let an older response land last.
      const request = (this.syncRequest = (this.syncRequest || 0) + 1);

      const attempt = (retriesLeft) =>
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: { [this.variantId]: quantity } }),
        })
          .then((res) => res.json().then((data) => ({ res, data })))
          .then(({ res, data }) => {
            if (request !== this.syncRequest) return;
            if (res.ok) {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
            } else if (res.status === 422 && !options.silent && this.errorBox) {
              this.errorBox.classList.add('is-visible');
            }
          })
          .catch(() => {
            if (request !== this.syncRequest) return;
            if (retriesLeft > 0) setTimeout(() => attempt(retriesLeft - 1), 800);
          });

      attempt(1);
    }

    syncNativeQuantityInputs(quantity) {
      const forms = Array.from(document.querySelectorAll('form[action]')).filter((form) => {
        const action = form.getAttribute('action') || '';
        return action.indexOf('/cart') !== -1;
      });

      forms.forEach((form) => {
        let input = form.querySelector('input[name="quantity"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          form.appendChild(input);
        }
        input.value = quantity;
      });

      let idInput = document.querySelector('form[action*="/cart"] input[name="id"]');
      if (idInput) idInput.value = this.variantId;
    }
  }

  customElements.define('dvtb-bundle-picker', DvtbBundlePicker);
}
